import _classCallCheck from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { isArgmaxDef, isArgminDef } from '../../aggregate';
import { isBinning } from '../../bin';
import { getPositionChannelFromLatLong, isGeoPositionChannel, isScaleChannel } from '../../channel';
import { binRequiresRange, isTypedFieldDef, vgField } from '../../channeldef';
import * as log from '../../log';
import { duplicate, hash as _hash, keys, replacePathInField, setEqual } from '../../util';
import { DataFlowNode } from './dataflow';

function addDimension(dims, channel, fieldDef, model) {
  if (isTypedFieldDef(fieldDef) && isBinning(fieldDef.bin)) {
    dims.add(vgField(fieldDef, {}));
    dims.add(vgField(fieldDef, {
      binSuffix: 'end'
    }));

    if (binRequiresRange(fieldDef, channel)) {
      dims.add(vgField(fieldDef, {
        binSuffix: 'range'
      }));
    }
  } else if (isGeoPositionChannel(channel)) {
    var posChannel = getPositionChannelFromLatLong(channel);
    dims.add(model.getName(posChannel));
  } else {
    dims.add(vgField(fieldDef));
  }

  return dims;
}

function mergeMeasures(parentMeasures, childMeasures) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = keys(childMeasures)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var field = _step.value;
      // when we merge a measure, we either have to add an aggregation operator or even a new field
      var ops = childMeasures[field];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = keys(ops)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var op = _step2.value;

          if (field in parentMeasures) {
            // add operator to existing measure field
            parentMeasures[field][op] = new Set([].concat(_toConsumableArray(parentMeasures[field][op] || []), _toConsumableArray(ops[op])));
          } else {
            parentMeasures[field] = _defineProperty({}, op, ops[op]);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

export var AggregateNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(AggregateNode, _DataFlowNode);

  /**
   * @param dimensions string set for dimensions
   * @param measures dictionary mapping field name => dict of aggregation functions and names to use
   */
  function AggregateNode(parent, dimensions, measures) {
    var _this;

    _classCallCheck(this, AggregateNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AggregateNode).call(this, parent));
    _this.dimensions = dimensions;
    _this.measures = measures;
    return _this;
  }

  _createClass(AggregateNode, [{
    key: "clone",
    value: function clone() {
      return new AggregateNode(null, new Set(this.dimensions), duplicate(this.measures));
    }
  }, {
    key: "merge",
    value: function merge(other) {
      if (setEqual(this.dimensions, other.dimensions)) {
        mergeMeasures(this.measures, other.measures);
        return true;
      } else {
        log.debug('different dimensions, cannot merge');
        return false;
      }
    }
  }, {
    key: "addDimensions",
    value: function addDimensions(fields) {
      fields.forEach(this.dimensions.add, this.dimensions);
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set([].concat(_toConsumableArray(this.dimensions), _toConsumableArray(keys(this.measures))));
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      var out = new Set();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = keys(this.measures)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var field = _step3.value;
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = keys(this.measures[field])[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var op = _step4.value;
              var m = this.measures[field][op];

              if (m.size === 0) {
                out.add("".concat(op, "_").concat(field));
              } else {
                m.forEach(out.add, out);
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return out;
    }
  }, {
    key: "hash",
    value: function hash() {
      return "Aggregate ".concat(_hash({
        dimensions: this.dimensions,
        measures: this.measures
      }));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var ops = [];
      var fields = [];
      var as = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = keys(this.measures)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var field = _step5.value;
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = keys(this.measures[field])[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var op = _step6.value;
              var _iteratorNormalCompletion7 = true;
              var _didIteratorError7 = false;
              var _iteratorError7 = undefined;

              try {
                for (var _iterator7 = this.measures[field][op][Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  var alias = _step7.value;
                  as.push(alias);
                  ops.push(op);
                  fields.push(field === '*' ? null : replacePathInField(field));
                }
              } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                    _iterator7.return();
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var result = {
        type: 'aggregate',
        groupby: _toConsumableArray(this.dimensions),
        ops: ops,
        fields: fields,
        as: as
      };
      return result;
    }
  }, {
    key: "groupBy",
    get: function get() {
      return this.dimensions;
    }
  }], [{
    key: "makeFromEncoding",
    value: function makeFromEncoding(parent, model) {
      var isAggregate = false;
      model.forEachFieldDef(function (fd) {
        if (fd.aggregate) {
          isAggregate = true;
        }
      });
      var meas = {};
      var dims = new Set();

      if (!isAggregate) {
        // no need to create this node if the model has no aggregation
        return null;
      }

      model.forEachFieldDef(function (fieldDef, channel) {
        var aggregate = fieldDef.aggregate,
            field = fieldDef.field;

        if (aggregate) {
          if (aggregate === 'count') {
            meas['*'] = meas['*'] || {};
            meas['*']['count'] = new Set([vgField(fieldDef, {
              forAs: true
            })]);
          } else {
            if (isArgminDef(aggregate) || isArgmaxDef(aggregate)) {
              var op = isArgminDef(aggregate) ? 'argmin' : 'argmax';
              var argField = aggregate[op];
              meas[argField] = meas[argField] || {};
              meas[argField][op] = new Set([vgField({
                op: op,
                field: argField
              }, {
                forAs: true
              })]);
            } else {
              meas[field] = meas[field] || {};
              meas[field][aggregate] = new Set([vgField(fieldDef, {
                forAs: true
              })]);
            } // For scale channel with domain === 'unaggregated', add min/max so we can use their union as unaggregated domain


            if (isScaleChannel(channel) && model.scaleDomain(channel) === 'unaggregated') {
              meas[field] = meas[field] || {};
              meas[field]['min'] = new Set([vgField({
                field: field,
                aggregate: 'min'
              }, {
                forAs: true
              })]);
              meas[field]['max'] = new Set([vgField({
                field: field,
                aggregate: 'max'
              }, {
                forAs: true
              })]);
            }
          }
        } else {
          addDimension(dims, channel, fieldDef, model);
        }
      });

      if (dims.size + keys(meas).length === 0) {
        return null;
      }

      return new AggregateNode(parent, dims, meas);
    }
  }, {
    key: "makeFromTransform",
    value: function makeFromTransform(parent, t) {
      var dims = new Set();
      var meas = {};
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = t.aggregate[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var s = _step8.value;
          var op = s.op,
              field = s.field,
              as = s.as;

          if (op) {
            if (op === 'count') {
              meas['*'] = meas['*'] || {};
              meas['*']['count'] = new Set([as ? as : vgField(s, {
                forAs: true
              })]);
            } else {
              meas[field] = meas[field] || {};
              meas[field][op] = new Set([as ? as : vgField(s, {
                forAs: true
              })]);
            }
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = (t.groupby || [])[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var _s = _step9.value;
          dims.add(_s);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      if (dims.size + keys(meas).length === 0) {
        return null;
      }

      return new AggregateNode(parent, dims, meas);
    }
  }]);

  return AggregateNode;
}(DataFlowNode);